export enum TRACKER_TYPE {
  account = 'account',
  general = 'general',
  payment = 'payment',
}
